/**
 * Retourne vrai si le jour est un jour d'entrée possible.
 * @param {object} param0.availability Les informations de l'API à propos de la date courante.
 */
export default function availabilityIsCheckinDay({ availability }) {
  return availability?.isCheckinDay ?? false;
}
